import React from "react";
import PropTypes from "prop-types";
import injectSheet from "react-jss";
import Link from "gatsby-link";

import Main from "../components/Main";
import Article from "../components/Main/Article";
import PageHeader from "../components/Page/PageHeader";
import Content from "../components/Main/Content";
import Seo from "../components/Seo";
import Footer from "../components/Footer";

const styles = theme => ({});

const SunLipProtection = () => {
  const data = {
    frontmatter: {
      title: "Best lip sun protection",
      description: "The top lip balm sunscreens for long sessions in the ocean",
      cover:
        "https://res.cloudinary.com/dx1tmklnq/image/upload/w_1000,c_scale/v1581132019/project_surf_helmet/20230721_112816_ewjcxp.jpg"
    }
  };
  const facebook = {};
  return (
    <Main>
      <Article>
        <PageHeader
          title="Best lip sun protection"
          subTitle="The top lip balm sunscreens for long sessions in the ocean"
        />
        <img
          src="https://res.cloudinary.com/dx1tmklnq/image/upload/w_1000,c_scale/v1581132019/project_surf_helmet/20230721_112816_ewjcxp.jpg"
          style={{ width: "100%", margin: "0 0 1.5em 0" }}
        />
        <Content>
          I don't know about you, but my lips used to constantly get burned surfing, especially just
          above my top lip and on my bottom lip during 2 hour sessions in the ocean.
          <br />
          <br />
          So a couple years ago, having located minimal info online, I started experimenting with
          different lip balm sunscreens with SPF. I found out that barely any of them stay on my
          lips long enough for a 2 hour session - only one combined chemical/mineral sunscreen does
          (my top choice, but it's not a lip balm!). Furthermore, I have found only one mineral, and
          therefore reef-safe, sunscreen that stays on close to 2 hours. Here are my top lip balm
          sunscreen choices currently on the market.
        </Content>
        <Content>
          <h3>Watermans High Performance Sunscreen and FacePro Performance Stick</h3>
          <img
            src="https://res.cloudinary.com/dx1tmklnq/image/upload/w_1000,c_scale/v1562895574/project_surf_helmet/PXL_20240727_184456495.PORTRAIT_geu8r4.jpg"
            style={{ width: "100%", margin: "0 0 1.5em 0" }}
          />
          <strong>Recommendation</strong>: Just finished testing this stuff in a variety of
          conditions for long periods of time in the water. It is a really amazing product which
          stays on your lips and face effectively. My theory is it has a lot to do with the beeswax;
          years ago I tried a sunscreen with beeswax that was almost impossible to scrub off.
          Although I don't know exactly what it is that gives it its holding ability, it seems like
          their Aqua-Armor tech definitely works. Unfortunately, it looks like the sunscreen tube
          version has chemicals in it - possibly making it not reef-safe - but the FacePro stick
          does not.
          <div
            style={{
              marginTop: "30px",
              marginBottom: "15px",
              width: "100%",
              paddingBottom: "45px",
              borderBottom: "1px solid #ccc"
            }}
          >
            <div style={{ margin: "0 auto", width: "max-content" }}>
              <a
                href="https://gowatermans.com/"
                target="_blank"
                style={{
                  borderRadius: "4px",
                  border: "none",
                  textAlign: "center",
                  cursor: "pointer",
                  fontSize: "16px",
                  msFlexItemAlign: "center",
                  msGridRowAlign: "center",
                  alignSelf: "center",
                  outline: "none",
                  fontFamily: "inherit",
                  fontWeight: 500,
                  textAlign: "center",
                  paddingLeft: "20px",
                  paddingRight: "20px",
                  height: "45px",
                  minWidth: "100px",
                  backgroundColor: "inherit",
                  color: "#010101",
                  border: "1px solid #010101",
                  fontWeight: 600,
                  textDecoration: "none",
                  paddingTop: "7.5px",
                  paddingBottom: "8.5px"
                }}
              >
                Order direct
              </a>
              <a
                href="https://amzn.to/3XdAfQC"
                target="_blank"
                style={{
                  color: "white",
                  borderRadius: "4px",
                  border: "none",
                  textAlign: "center",
                  cursor: "pointer",
                  fontSize: "16px",
                  msFlexItemAlign: "center",
                  msGridRowAlign: "center",
                  alignSelf: "center",
                  outline: "none",
                  fontFamily: "inherit",
                  fontWeight: 500,
                  textAlign: "center",
                  paddingLeft: "20px",
                  paddingRight: "20px",
                  height: "47px",
                  minWidth: "100px",
                  backgroundColor: "#ee5a5a",
                  marginLeft: "30px",
                  fontWeight: 600,
                  textDecoration: "none",
                  paddingTop: "9px",
                  paddingBottom: "10px"
                }}
              >
                Amazon price
              </a>
            </div>
          </div>
          <h3>Shiseido Ultimate Sun Protector Face Cream with SynchroShield</h3>
          <img
            src="https://res.cloudinary.com/dx1tmklnq/image/upload/w_1000,c_scale/v1562895574/project_surf_helmet/20230721_112513_mmkklr.jpg"
            style={{ width: "100%", margin: "0 0 1.5em 0" }}
          />
          <strong>Recommendation</strong>: I don't know what they're doing with their SynchroShield
          tech, but the stuff just doesn't come off except with a hard scrub in the shower. Perfect
          for someone who apparently subconsiously rubs and licks his own lips. It will make you
          look like a vampire (yes it leaves a white residue) and has a slight chemical,
          perfume-like smell and taste, but it's well worth it when the UV index is high and most
          damaging during long sessions in the ocean. I'm talking about those sessions when you
          start thinking about what your skin is going to look like later in life... I should
          mention that it's technically not reef safe, so please only use it on your lips & face in
          the ocean when you need it most.
          <div
            style={{
              marginTop: "30px",
              marginBottom: "15px",
              width: "100%",
              paddingBottom: "45px",
              borderBottom: "1px solid #ccc"
            }}
          >
            <div style={{ margin: "0 auto", width: "max-content" }}>
              <a
                href="https://www.shiseido.com/us/en/ultimate-sun-protector-cream-spf-50-sunscreen-0730852156760.html"
                target="_blank"
                style={{
                  borderRadius: "4px",
                  border: "none",
                  textAlign: "center",
                  cursor: "pointer",
                  fontSize: "16px",
                  msFlexItemAlign: "center",
                  msGridRowAlign: "center",
                  alignSelf: "center",
                  outline: "none",
                  fontFamily: "inherit",
                  fontWeight: 500,
                  textAlign: "center",
                  paddingLeft: "20px",
                  paddingRight: "20px",
                  height: "45px",
                  minWidth: "100px",
                  backgroundColor: "inherit",
                  color: "#010101",
                  border: "1px solid #010101",
                  fontWeight: 600,
                  textDecoration: "none",
                  paddingTop: "7.5px",
                  paddingBottom: "8.5px"
                }}
              >
                Order direct
              </a>
              <a
                href="https://www.amazon.com/Shiseido-Protector-Sunscreen-SynchroShield-HeatForce/dp/B0859R8S5N?&_encoding=UTF8&tag=projectsurfhe-20&linkCode=ur2&linkId=cefaf54c82ed6a3aa2e31cd0fc4bf2a4&camp=1789&creative=9325"
                target="_blank"
                style={{
                  color: "white",
                  borderRadius: "4px",
                  border: "none",
                  textAlign: "center",
                  cursor: "pointer",
                  fontSize: "16px",
                  msFlexItemAlign: "center",
                  msGridRowAlign: "center",
                  alignSelf: "center",
                  outline: "none",
                  fontFamily: "inherit",
                  fontWeight: 500,
                  textAlign: "center",
                  paddingLeft: "20px",
                  paddingRight: "20px",
                  height: "47px",
                  minWidth: "100px",
                  backgroundColor: "#ee5a5a",
                  marginLeft: "30px",
                  fontWeight: 600,
                  textDecoration: "none",
                  paddingTop: "9px",
                  paddingBottom: "10px"
                }}
              >
                Amazon price
              </a>
            </div>
          </div>
          <h3>Raw Elements Face & Body</h3>
          <img
            src="https://res.cloudinary.com/dx1tmklnq/image/upload/w_1000,c_scale/v1581132019/project_surf_helmet/20230721_112333_xuauxx.jpg"
            style={{ width: "100%", margin: "0 0 1.5em 0" }}
          />
          <strong>Recommendation</strong>: This stuff is soft and buttery to the touch, really stays
          on, protects well, and doesn't have a sour, chemical taste. Everything you could want for
          a reef-safe sunscreen. However, don't expect it to prevent burns in a 2 hour session -
          although it stays on better than other sunscreens I tested, if you subconsciously rub your
          lips it will eventually rub off.
          <div
            style={{
              marginTop: "30px",
              marginBottom: "15px",
              width: "100%",
              paddingBottom: "45px",
              borderBottom: "1px solid #ccc"
            }}
          >
            <div style={{ margin: "0 auto", width: "max-content" }}>
              <a
                href="https://www.rawelementsusa.com/products/face-body-30-tin-plastic-free"
                target="_blank"
                style={{
                  borderRadius: "4px",
                  border: "none",
                  textAlign: "center",
                  cursor: "pointer",
                  fontSize: "16px",
                  msFlexItemAlign: "center",
                  msGridRowAlign: "center",
                  alignSelf: "center",
                  outline: "none",
                  fontFamily: "inherit",
                  fontWeight: 500,
                  textAlign: "center",
                  paddingLeft: "20px",
                  paddingRight: "20px",
                  height: "45px",
                  minWidth: "100px",
                  backgroundColor: "inherit",
                  color: "#010101",
                  border: "1px solid #010101",
                  fontWeight: 600,
                  textDecoration: "none",
                  paddingTop: "7.5px",
                  paddingBottom: "8.5px"
                }}
              >
                Order direct
              </a>
              <a
                href="https://www.amazon.com/Raw-Elements-Certified-Sunscreen-Moisturizing/dp/B01H3PN27M?&_encoding=UTF8&tag=projectsurfhe-20&linkCode=ur2&linkId=f7357c20d01f0a0137ca3dfd232ece35&camp=1789&creative=9325"
                target="_blank"
                style={{
                  color: "white",
                  borderRadius: "4px",
                  border: "none",
                  textAlign: "center",
                  cursor: "pointer",
                  fontSize: "16px",
                  msFlexItemAlign: "center",
                  msGridRowAlign: "center",
                  alignSelf: "center",
                  outline: "none",
                  fontFamily: "inherit",
                  fontWeight: 500,
                  textAlign: "center",
                  paddingLeft: "20px",
                  paddingRight: "20px",
                  height: "47px",
                  minWidth: "100px",
                  backgroundColor: "#ee5a5a",
                  marginLeft: "30px",
                  fontWeight: 600,
                  textDecoration: "none",
                  paddingTop: "9px",
                  paddingBottom: "10px"
                }}
              >
                Amazon price
              </a>
            </div>
          </div>
          <h3>Shiseido Clear Stick UV Protector with WetForce</h3>
          <img
            src="https://res.cloudinary.com/dx1tmklnq/image/upload/w_1000,c_scale/v1562895626/project_surf_helmet/20230721_112732_i4hdzf.jpg"
            style={{ width: "100%", margin: "0 0 1.5em 0" }}
          />
          <strong>Recommendation</strong>: Performs and protects almost as well as the Ultimate Sun
          Protector Face Cream but leaves no white residue.
          <div
            style={{
              marginTop: "30px",
              marginBottom: "15px",
              width: "100%",
              paddingBottom: "45px",
              borderBottom: "1px solid #ccc"
            }}
          >
            <div style={{ margin: "0 auto", width: "max-content" }}>
              <a
                href="https://www.shiseido.com/us/en/clear-sunscreen-stick-spf-50-0730852169807.html"
                target="_blank"
                style={{
                  borderRadius: "4px",
                  border: "none",
                  textAlign: "center",
                  cursor: "pointer",
                  fontSize: "16px",
                  msFlexItemAlign: "center",
                  msGridRowAlign: "center",
                  alignSelf: "center",
                  outline: "none",
                  fontFamily: "inherit",
                  fontWeight: 500,
                  textAlign: "center",
                  paddingLeft: "20px",
                  paddingRight: "20px",
                  height: "45px",
                  minWidth: "100px",
                  backgroundColor: "inherit",
                  color: "#010101",
                  border: "1px solid #010101",
                  fontWeight: 600,
                  textDecoration: "none",
                  paddingTop: "7.5px",
                  paddingBottom: "8.5px"
                }}
              >
                Order direct
              </a>
              <a
                href="https://www.amazon.com/Shiseido-Ultimate-Protector-Lotion-Broad-Spectrum/dp/B0921KVV27?&_encoding=UTF8&tag=projectsurfhe-20&linkCode=ur2&linkId=35d88ac04112180c10c1cd9d235d0ab4&camp=1789&creative=9325"
                target="_blank"
                style={{
                  color: "white",
                  borderRadius: "4px",
                  border: "none",
                  textAlign: "center",
                  cursor: "pointer",
                  fontSize: "16px",
                  msFlexItemAlign: "center",
                  msGridRowAlign: "center",
                  alignSelf: "center",
                  outline: "none",
                  fontFamily: "inherit",
                  fontWeight: 500,
                  textAlign: "center",
                  paddingLeft: "20px",
                  paddingRight: "20px",
                  height: "47px",
                  minWidth: "100px",
                  backgroundColor: "#ee5a5a",
                  marginLeft: "30px",
                  fontWeight: 600,
                  textDecoration: "none",
                  paddingTop: "9px",
                  paddingBottom: "10px"
                }}
              >
                Amazon price
              </a>
            </div>
          </div>
          <h3>Notable Mentions that I've tested</h3>
          These all worked decently, but didn't stand the test of a 2 hour session.
          <h4>
            <a
              target="_blank"
              href="https://www.amazon.com/Headhunter-Chapstick-Sunscreen-Protection-Waterproof/dp/B08MDP5XD1?&_encoding=UTF8&tag=projectsurfhe-20&linkCode=ur2&linkId=b36946e52a4bab3a38d279e2dea79d29&camp=1789&creative=9325"
            >
              Head Hunter Lip Protectant
            </a>
          </h4>
          <h4>
            <a
              target="_blank"
              href="https://www.amazon.com/Vertra-Ehukai-Beige-Face-Stick/dp/B07RZM1Q34?&_encoding=UTF8&tag=projectsurfhe-20&linkCode=ur2&linkId=a908e9ca60a9cffa0527e3901f9c2ccd&camp=1789&creative=9325"
            >
              Vertra Sunscreen Face Stick
            </a>
          </h4>
          <h4>
            <a
              target="_blank"
              href="https://www.amazon.com/Vertra-Lava-Hibiscus-Lip-Balm/dp/B07PB49DPD?&_encoding=UTF8&tag=projectsurfhe-20&linkCode=ur2&linkId=47def20bc62fe604b5317443ca202027&camp=1789&creative=9325"
            >
              Vertra Lip Balm
            </a>
          </h4>
          <h4>
            <a
              target="_blank"
              href="https://www.amazon.com/Sun-Bum-SPF-Signature-Balm/dp/B07DFSSN6T?&_encoding=UTF8&tag=projectsurfhe-20&linkCode=ur2&linkId=81d4561dc1639fd163ce2d81dabefc86&camp=1789&creative=9325"
            >
              Sun Bum Signature Lip Balm
            </a>
          </h4>
          <h4>
            <a
              target="_blank"
              href="https://www.amazon.com/Beach-Day-Bundle-TropicSport-Sunscreen/dp/B08J4BR35M?&_encoding=UTF8&tag=projectsurfhe-20&linkCode=ur2&linkId=62d60e55a6aa8ccf071d3eccfc03e1fd&camp=1789&creative=9325"
            >
              TropicSport
            </a>
          </h4>
        </Content>
      </Article>
      <Footer footnote={data} />
      <Seo data={data} facebook={facebook} page />
    </Main>
  );
};

SunLipProtection.propTypes = {
  classes: PropTypes.object.isRequired
};

export default injectSheet(styles)(SunLipProtection);



// WEBPACK FOOTER //
// ./src/pages/lip-sun-protection.js